import { Image, ImageProps } from 'expo-image';

interface ConfirmHeaderOverlayProps {
  backgroundColor?: string;
  source: ImageProps['source'];
}

export const ConfirmHeaderOverlay = ({ source }: ConfirmHeaderOverlayProps) => (
  <Image source={source} style={{ position: 'absolute', top: 0, bottom: 0, left: 0, right: 0 }} />
);
